import { PcmpAccountsQueueTable } from '../components/PcmpAccountsQueue/PcmpAccountsQueueTable';

export function PcmpAccountsQueuePage() {
  return <PcmpAccountsQueueTable />;
}
